import React, { useEffect, useState } from 'react';
import { Menu, X } from 'lucide-react';
import { BrandMark } from './BrandMark';
interface NavbarProps {
  onOpenForm: () => void;
}
export function Navbar({
  onOpenForm
}: NavbarProps) {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navItems = [{
    label: 'Research',
    href: '#research'
  }, {
    label: 'Methodology',
    href: '/research-methodology'
  }, {
    label: 'FAQ',
    href: '#faq'
  }, {
    label: 'About',
    href: '/editorial-standards'
  }];
  return <header className={`fixed top-0 left-0 right-0 z-40 transition-all duration-300 border-b ${isScrolled ? 'bg-white/95 backdrop-blur-md border-slate-200 py-3' : 'bg-white border-slate-100 py-4'}`} data-id="element-385">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex justify-between items-center gap-6" data-id="element-386">
        {/* Brand */}
        <a href="/" className="flex items-center gap-3 hover:opacity-85 transition-opacity" aria-label="Blinkblis home" data-id="element-387">
          <BrandMark className="w-7 h-7 md:w-9 md:h-9 flex-shrink-0" data-id="element-388" />
          <span className="text-lg md:text-xl font-bold tracking-tight leading-none" data-id="element-389">
            <span className="text-navy-900" data-id="element-390">blink</span>
            <span className="text-emerald-600" data-id="element-391">blis</span>
          </span>
        </a>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center gap-8" data-id="element-392">
          {navItems.map(item => <a key={item.label} href={item.href} className="text-sm font-medium text-slate-600 hover:text-slate-900 transition-colors relative group" data-id="element-393">
              {item.label}
              <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-emerald transition-all duration-300 group-hover:w-full" data-id="element-394"></span>
            </a>)}
        </nav>

        {/* Mobile Menu Toggle */}
        <button onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} className="md:hidden p-2 text-slate-600 hover:text-navy transition-colors" aria-label="Toggle menu" data-id="element-395">
          {isMobileMenuOpen ? <X className="w-6 h-6" data-id="element-396" /> : <Menu className="w-6 h-6" data-id="element-397" />}
        </button>
      </div>

      {/* Mobile Nav Dropdown */}
      {isMobileMenuOpen && <div className="md:hidden absolute top-full left-0 right-0 bg-white border-b border-slate-200 shadow-lg py-6 px-4 flex flex-col items-center" data-id="element-398">
          <BrandMark className="w-10 h-10 mb-6" data-id="element-399" />
          <div className="w-full flex flex-col space-y-4" data-id="element-400">
            {navItems.map(item => <a key={item.label} href={item.href} onClick={() => setIsMobileMenuOpen(false)} className="text-base font-medium text-slate-600 hover:text-navy py-2 border-b border-slate-50 text-center" data-id="element-401">
                {item.label}
              </a>)}
          </div>
        </div>}
    </header>;
}